import userService from "../../../services/user.service";

async function addDesignationLevelToDatabase({
  designationLevelName,
  designationLevelDescription,
  isActive,
}) {
  try {
    const response = await userService.addDesignationLevel({
      name: designationLevelName,
      description: designationLevelDescription,
      active: isActive,
    });
    if (response.data && response.data.status) {
      return "Designation Level added Successfully!";
    } else {
      return response.data.message || "Failed to add designation level.";
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    return JSON.stringify(errorMessage);
  }
}

async function getDesignationLevels() {
  try {
    const response = await userService.getDesignationsLevel(-1, 0, "");
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to get designation levels."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    return JSON.stringify(errorMessage);
  }
}

export default {
  addDesignationLevelToDatabase,
  getDesignationLevels,
  designationLevelTools: [
    {
      type: "function",
      function: {
        name: "addDesignationLevelToDatabase",
        description: "Add a designation level to the database",
        parameters: {
          type: "object",
          properties: {
            designationLevelName: {
              type: "string",
              description: "Name of the designation level",
            },
            designationLevelDescription: {
              type: "string",
              description: "Description of the designation level",
            },
            isActive: {
              type: "boolean",
              description: "Whether the designation level is active or not",
            },
          },
          required: [
            "designationLevelName",
            "designationLevelDescription",
            "isActive",
          ],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "getDesignationLevels",
        description: "Get designation levels from database",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    }
  ]
};